import { render, staticRenderFns } from "./mute.vue?vue&type=template&id=6072860f&scoped=true"
import script from "./mute.vue?vue&type=script&lang=js"
export * from "./mute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6072860f",
  null
  
)

export default component.exports